import { render, staticRenderFns } from "./AnaliseBalanceamento.vue?vue&type=template&id=4f20cbd4&scoped=true"
import script from "./AnaliseBalanceamento.vue?vue&type=script&lang=js"
export * from "./AnaliseBalanceamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20cbd4",
  null
  
)

export default component.exports